import { createSelector } from 'reselect'

const getSubteam = (subteams, id) => subteams.find(subteam => subteam.id === id);
export const makeGetSubteam = () => createSelector(getSubteam, subteam => subteam);

const getSortedActiveSubteams = subteams => subteams
    .filter(subteam => subteam && !subteam.error && !subteam.archived)
    .sort((s1, s2) => {
        if (!s1) return 1;
        if (!s2) return -1;

        const s1Name = (s1.name && s1.name.toLowerCase());
        const s2Name = (s2.name && s2.name.toLowerCase());

        if (s1Name > s2Name) return 1;
        if (s1Name < s2Name) return -1;

        return 0;
    });
export const makeGetSortedActiveSubteams = () => createSelector(getSortedActiveSubteams, subteams => subteams);
